var _a, _b, _c, _d, _e, _f;
import { __decorate, __metadata } from "tslib";
import { cookies, ITimeoutService, IScope } from 'angular';
import { debounce } from 'data/function';
import { Component } from 'decorators';
import { AccountUpdated } from 'modules/account/account/AccountController';
import { IStateService } from 'angular-ui-router';
import { AccountService2 } from 'modules/account/AccountService2';
import { ContextProcessorService } from 'modules/core/ContextProcessorService';
import { NavbarFeatures } from '../NavbarFeatures';
import template from './MainNavbarView.html';
import './mainNavbar.scss';
const CLOSED_MKT_BANNER = 'blip-closed-mkt-banner';
let MainNavbarComponent = class MainNavbarComponent {
    static $inject = ['$timeout', '$cookies', '$rootScope', '$scope', 'AccountService2', 'ContextProcessorService', '$state'];
    constructor($timeout, $cookies, $rootScope, $scope, AccountService2, ContextProcessorService, $state) {
        'ngInject';
        this.$timeout = $timeout;
        this.$cookies = $cookies;
        this.$rootScope = $rootScope;
        this.$scope = $scope;
        this.AccountService2 = AccountService2;
        this.ContextProcessorService = ContextProcessorService;
        this.$state = $state;
        this.iframeMarketingUrl = false;
        this.isPipeline = false;
        this.application = {};
        $scope.$watch(() => {
            return $state.current.name;
        }, (newVal, oldVal) => {
            this.isPipeline = this.$rootScope.application.template === 'pipeline';
            if (newVal === 'auth.application.detail.builder.index' && this.isPipeline) {
                this.isPipeline = false;
            }
        });
    }
    async $onInit() {
        await this.ContextProcessorService.waitForInitialization();
        this.currentTenant = this.ContextProcessorService.tenant;
        await this.userAccount();
        // Store the unregister function returned by $on
        this.accountUpdatedUnregister = this.$rootScope.$on(AccountUpdated, this.userAccount.bind(this));
        // Initialize marketing banner
        this.iframeMarketingUrl = await NavbarFeatures.isMarketingBannerEnabled();
        this.initializeScrollListeners();
        // Clean up on scope destroy
        this.$scope.$on('$destroy', () => {
            if (this.accountUpdatedUnregister) {
                this.accountUpdatedUnregister();
            }
            // Remove scroll event listener
            if (this.scrollEventHandler) {
                window.removeEventListener('scroll', this.scrollEventHandler);
            }
        });
    }
    initializeScrollListeners() {
        this.header = document.getElementById('main-navbar');
        this.debouncedNavbarScroll = debounce(this.handleNavbarScroll, 150);
        window.addEventListener('scroll', () => this.$timeout(() => this.debouncedNavbarScroll()), { passive: true });
    }
    handleNavbarScroll() {
        const MIN_SCROLL_HEIGHT = 40;
        const pageWasScrolled = this.header.offsetHeight < (window.pageYOffset + MIN_SCROLL_HEIGHT);
        pageWasScrolled
            ? this.header.classList.add('main-header-collapsed')
            : this.header.classList.remove('main-header-collapsed');
    }
    showMarketingBanner() {
        return (!this.$cookies.getObject(CLOSED_MKT_BANNER) &&
            this.iframeMarketingUrl !== 'undefined' &&
            this.iframeMarketingUrl !== false);
    }
    closeMarketingBanner() {
        const expiration = new Date();
        expiration.setDate(expiration.getDate() + 5);
        this.$cookies.putObject(CLOSED_MKT_BANNER, this.iframeMarketingUrl, {
            expires: expiration,
        });
        this.iframeMarketingUrl = false;
    }
    async userAccount() {
        this.user = await this.AccountService2.me();
    }
};
MainNavbarComponent.$inject = ['$timeout', '$cookies', '$rootScope', '$scope', 'AccountService2', 'ContextProcessorService', '$state'];
MainNavbarComponent = __decorate([
    Component({
        template,
        bindings: {},
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof ITimeoutService !== "undefined" && ITimeoutService) === "function" ? _a : Object, typeof (_b = typeof cookies !== "undefined" && cookies.ICookiesService) === "function" ? _b : Object, Object, typeof (_c = typeof IScope !== "undefined" && IScope) === "function" ? _c : Object, typeof (_d = typeof AccountService2 !== "undefined" && AccountService2) === "function" ? _d : Object, typeof (_e = typeof ContextProcessorService !== "undefined" && ContextProcessorService) === "function" ? _e : Object, typeof (_f = typeof IStateService !== "undefined" && IStateService) === "function" ? _f : Object])
], MainNavbarComponent);
export { MainNavbarComponent };
